"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const shouldDownloadUpgrade = () => {
  const userAgent = window.navigator.userAgent
  const match = userAgent.match(/Electron\/([0-9]+)/)
  if (!match) {
    return false
  }
  // `<` between a string and a number already converts the string with
  // Number(); this makes that conversion explicit for TypeScript.
  return Number(match[1]) < 28 // BloomText/1.20.0
}; exports.shouldDownloadUpgrade = shouldDownloadUpgrade
